import { NgModule } from '@angular/core';
import { FormsModule }  from '@angular/forms';
import { CommonModule } from '@angular/common';

import { InteditComponent } from './intedit.component';
import { InteditRoutingModule } from './intedit.routing.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    InteditRoutingModule,
    ReactiveFormsModule
  ],
  exports: [
    InteditComponent
  ],
  declarations: [
    InteditComponent
  ],
})
export class InteditModule { }
